import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Components/Website/Home";
import Login from "./Pages/Auth/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Users from "./Pages/Dashboard/Users/Users";
import MaterialsPage from "./Components/Website/Product/Materials/MaterialsPage";
import AboutPage from "./Components/Website/About/AboutPage";
import ProfilePage from "./Components/Website/Product/Profile/ProfilePage";
import AddStudent from "./Pages/Dashboard/Users/AddStudent";
import Err403 from "./Pages/Errors/403";
import Err404 from "./Pages/Errors/404";
import Student from "./Pages/Dashboard/Users/Student";
import Material from "./Pages/Dashboard/Materials/Material";
import AddMaterial from "./Pages/Dashboard/Materials/AddMaterial";
import Categories from "./Pages/Dashboard/Materials/Categories";
import Products from "./Pages/Dashboard/Lesson/Products";
import UpdateLesson from "./Pages/Dashboard/Lesson/Lesson";
import AddLesson from "./Pages/Dashboard/Lesson/AddLesson";
import T_Intensive from "./Pages/Dashboard/IntensiveCourse/T-Intensive";
import Intensive from "./Pages/Dashboard/IntensiveCourse/IntensiveCo";
import AddIntensive from "./Pages/Dashboard/IntensiveCourse/AddIntensiveCo";
import IntensiveLectures from "./Pages/Dashboard/IntensiveCourse/IntensiveLectures";
import EnrollIntensive from "./Pages/Dashboard/IntensiveCourse/EnrollIntensive";
import Add_Ads from "./Pages/Dashboard/Ads/Add_Ads";
import Ads from "./Pages/Dashboard/Ads/Ads";
import T_Ads from "./Pages/Dashboard/Ads/T_Ads";
import Classes from "./Pages/Dashboard/Classes/Classes";
import AddClass from "./Pages/Dashboard/Classes/AddClass";
import EditClass from "./Pages/Dashboard/Classes/EditClass";
import ExcellentStudents from "./Pages/Dashboard/ExcellentStudents/ExcellentStudents";
import Gallery from "./Pages/Dashboard/Gallery/Gallery";
import Settings from "./Pages/Dashboard/Settings/Settings";
import Notifications from "./Pages/Dashboard/Notifications/Notifications";
import SendNotification from "./Pages/Dashboard/Notifications/SendNotification";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/materials" element={<MaterialsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/err403" element={<Err403 />} />

        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="users" element={<Users />} />
          <Route path="users/:id" element={<Student />} />
          <Route path="user/add" element={<AddStudent />} />
          {/* Categories */}
          <Route path="categories" element={<Categories />} />
          <Route path="categories/:id" element={<Material />} />
          <Route path="category/add" element={<AddMaterial />} />
          {/* Products */}
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<UpdateLesson />} />
          <Route path="product/add" element={<AddLesson />} />
          {/* Intensive Courses */}
          <Route path="T_Intensive" element={<T_Intensive />} />
          <Route path="Intensive/:id" element={<Intensive />} />
          <Route path="Intensive/add" element={<AddIntensive />} />
          <Route path="Intensive/:id/lectures" element={<IntensiveLectures />} />
          <Route path="Intensive/:id/enroll" element={<EnrollIntensive />} />
          {/* Classes */}
          <Route path="classes" element={<Classes />} />
          <Route path="classes/:id" element={<EditClass />} />
          <Route path="class/add" element={<AddClass />} />
          {/* Ads */}
          <Route path="T_Ads" element={<T_Ads />} />
          <Route path="Ads/:id" element={<Ads />} />
          <Route path="Ad/add" element={<Add_Ads />} />
          {/* Excellent Students */}
          <Route path="excellent" element={<ExcellentStudents />} />
          {/* Notifications */}
          <Route path="notifications" element={<Notifications />} />
          <Route path="notification/send" element={<SendNotification />} />
          {/* Gallery */}
          <Route path="gallery" element={<Gallery />} />
          {/* Settings */}
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* 404 — must be last */}
        <Route path="*" element={<Err404 />} />
      </Routes>
    </div>
  );
}

export default App;
